const STATE = {
    NOSTATE: -1,
    IDLE: 0,
    SHOW: 1,
    DEMO_SELECTED: 2,
    DEMO_DISABLED: 3
};

const EVENTS = {
    DEMO_READY: 'demoready',
    DEMO_START: 'demostart',
    DEMO_SELECTED: 'demoselected',
    DEMO_END: 'demoend',
    DEMO_DISABLED: 'demodisabled'
};

let rigger;

cc.Class({
    extends: cc.Component,

    properties: {
        sprite: cc.SpriteFrame,
        buttonSize: cc.Vec2,

        buttonPrefab: cc.Prefab,
        normal: cc.Color,
        hover: cc.Color,
        pressed: cc.Color,
        disabled: cc.Color,
        showDemo: cc.Color,
        hideDemo: cc.Color,
        cancelDemo: cc.Color
    },

    statics: {
        STATE,
        EVENTS
    },

    ctor () {
        this._state = STATE.IDLE;
        this._activeDemoName = '';
    },

    onLoad () {
        this._cancelButton = this.node.getChildByName('CancelButton');
        this._showbutton = this.node.getChildByName('ShowDemoButton').getComponent(cc.Button);
        this._hideButton = this.node.getChildByName('HideDemoButton');
        this._eventsDLButton = this.node.getChildByName('DLEventsButton');
        this._demoContainer = this.node.getChildByName('DemoContainer');
        this._widget = this.node.getComponent(cc.Widget);
        this._layout = this._demoContainer.getComponent(cc.Layout);
    },

    start () {
        this._init();
        this._changeState();
        this._updateWidget();

        // // check settings for debug fps
        const enabledFps = false;

        cc.debug.setDisplayStats(enabledFps);
    },

    _init () {
        rigger = window.PSGames.CommonAPI.Rigger;

        this.gameName = require('PSConfig').get().gameName;
        this._state = STATE.NOSTATE;
        this._demoContainer.removeAllChildren();

        initColor.call(this);
        initHideButton.call(this);

        let newHeight = this._cancelButton.height;
        const cheatList = rigger.listCheats();
        cheatList.forEach((item) => {
            const node = cc.instantiate(this.buttonPrefab);

            node.name = `${item}Button`;
            node.color =  new cc.Color(255, 255, 255);
            node.opacity = 255;

            node.getComponentInChildren(cc.Label).string = item;
            createButton.call(this, node, item);

            node.width = this.buttonSize.x;
            node.height = this.buttonSize.y;
            node.parent = this._demoContainer;

            newHeight += this.buttonSize.y;

        });

        initDLEventsButton.call(this);

        updateLayout.call(this);

        function updateLayout () {
            this._layout.updateLayout();

            // eslint-disable-next-line no-underscore-dangle
            cc._widgetManager.onResized();
        }

        function initColor () {
            this._cancelButton.color = this.cancelDemo;
            this._showbutton.node.color = this.showDemo;
            this._hideButton.color = this.hideDemo;
        }

        function initHideButton () {
            this._hideButton.x = 0;
            this._hideButton.y = 0;
            this._hideButton.width = this.buttonSize.x;
            this._hideButton.height = this.buttonSize.y;
            this._hideButton.parent = this._demoContainer;
        }

        function initDLEventsButton () {
            this._eventsDLButton.parent = this._demoContainer;
        }

        function createButton (node, item) {
            const buttonCC = node.getComponent(cc.Button);

            buttonCC.transition = cc.Button.Transition.COLOR;
            buttonCC.normalColor = this.normal;
            buttonCC.pressedColor = this.pressed;
            buttonCC.hoverColor = this.hover;
            buttonCC.disabledColor = this.disabled;

            const clickEventHandler = new cc.Component.EventHandler();

            clickEventHandler.target = this.node; //This node is the node to which your event handler code component belongs
            clickEventHandler.component = 'DemoController';//This is the code file name
            clickEventHandler.handler = 'callback';
            clickEventHandler.customEventData = item;

            const button = node.getComponent(cc.Button);

            button.clickEvents.push(clickEventHandler);
        }
    },

    _updateWidget () {
        this._widget.top = 0;
        this._widget.left = 0;

        this.node.x = 0;
        this.node.y = 0;
    },

    _changeState (newState = STATE.IDLE) {
        if (this._state === newState) {
            return;
        }

        this._state = newState;

        switch (this._state) {
            default:
            case STATE.IDLE:
                this._cancelButton.active = false;
                this._showbutton.node.active = true;
                this._demoContainer.active = false;
                this._showbutton.interactable = true;
                break;
            case STATE.SHOW:
                this._cancelButton.active = false;
                this._showbutton.node.active = false;
                this._demoContainer.active = true;
                this._showbutton.interactable = true;
                break;
            case STATE.DEMO_SELECTED:
                this._showbutton.node.active = true;
                this._demoContainer.active = false;
                this._showbutton.interactable = true;
                break;
            case STATE.DEMO_DISABLED:
                this._cancelButton.active = false;
                this._showbutton.node.active = true;
                this._demoContainer.active = false;
                this._showbutton.interactable = false;
                break;
        }
    },

    callback (_event, key) {
        this._activeDemoName = key;
        rigger.triggerCheat(key);
        this._changeState(STATE.DEMO_SELECTED);
    },

    show () {
        this._changeState(STATE.SHOW);
    },

    hide () {
        this._changeState(STATE.IDLE);
    },

    cancel () {
        this._resetValues();
        this._changeState(STATE.IDLE);
    },

    stop () {
        this._resetValues();
        this._changeState(STATE.IDLE);
    }
});
